import React from 'react'
// import CustomTable from '../../common/customTable'
// import MyImage from '../../common/myImage'
import styles from './style.module.scss'

// import MyImage from '@shared/components/myImage'
import icon from '@assets/images/chess/icon.png'
import PropTypes from 'prop-types'
import CustomTable from '@shared/components/olympics/common/customTable'
import MyImage from '@shared/components/myImage'

export default function ChessTable({ data }) {
  const bodyData = data?.aStats.map((ele, index) => {
    return [
      <div key={index} className="d-flex">
        <div className={styles.title} >
          <MyImage src={ele?.oTeam?.oImg?.sUrl} height={24} width={24} style={{ borderRadius: '50%' }} />
          {ele?.oTeam?.sSrtTitle}
        </div>
      </div>,
      ele?.nMatches,
      ele?.nWins,
      ele?.nLosses,
      data?.nDraws || 0,
      ele?.nGamePoints,
      ele?.nMatchPoints
    ]
  })

  const tableData = {
    header: ['Team', 'M', 'W', 'L', 'D', 'GP', 'MP'],
    body: bodyData
  }

  return (
    <>
    {/* <h3 className="small-head d-flex align-items-center  mb-3">
          <span>Standings</span>
        </h3> */}
    <div className={styles.leaguePointsTable}>
      <div className={`d-flex align-items-center ${styles.tableBanner}`}>
        <div>
          <MyImage className={styles.logo} src={icon} />
        </div>
        <div className={styles.tableCntr}>
          <div className={styles.tableTitle}>Standings</div>
          {/* <div className={styles.tableSubTitle}>Standings</div> */}
        </div>
      </div>
      <CustomTable
        table={tableData}
        noData={data?.aCountryStats?.length <= 0}
        smallTable
        isChess
        // slug={'https://globalchessleague.com/season_1/'}
      />
    </div>
    </>
  )
}

ChessTable.propTypes = {
  data: PropTypes.object
}
